import api from './client'

export async function getCurrentPlan() {
  const res = await api.get('/auth/current-plan')
  return res.data
}

export async function changePlan(plan: string) {
  const res = await api.post('/auth/change-plan', { plan })
  return res.data
}

export async function verifySubscription(data: {
  subscription_id: string
  payment_id: string
  payment_signature: string
}) {
  const res = await api.post('/auth/verify-subscription', data)
  return res.data
}

export async function cancelSubscription() {
  const res = await api.post('/auth/cancel-subscription')
  return res.data
}

export async function getRazorpayConfig(): Promise<{ key_id: string }> {
  const res = await api.get('/auth/razorpay-config')
  return res.data
}
